import React from 'react'
import logo from '../../assets/images/logo-brandprotection.svg'

interface ILogoProps {
  className?: string
}

export const MagaluWordmark: React.FC<ILogoProps> = ({ className }) => (
  <img src={logo} data-testid="logo-magalu-wordmark" alt="magalu logo" className={className} />
)
